enum LifeInsuranceProcessStepEnum {
  RATER = 1, // Tarificacion
  DOCUMENTS = 2, // Profesiones o Documentos
  HOLDER = 3, // Tomador
  INSUREDS = 4, // Asegurados
  QUESTIONNAIRES = 5, // Cuestionarios
  BENEFICIARIES = 6, // Beneficiarios
  PAYMENT = 7, // MediosPago
  EMISSION = 8 // Emision
}

export default LifeInsuranceProcessStepEnum
